import { FINANCE_ONBOARDING_STEP as S } from 'app-redux/financeOnboardingSlice'

const INVOICES = /^\/sales\/invoices\/?$/
const INVOICE_ADD = /^\/sales\/invoices\/add/
const INVOICE_DETAIL = /^\/sales\/invoices\/detail\/\d+/
const PROFIT_LOSS = /^\/reports\/profit-loss/

// Dropdown kontak/produk dirender di dalam container suggestion-nya (getPopupContainer).
// Lubang fokus hanya ikut dropdown milik select yang disorot, bukan dropdown lain yang
// masih dalam animasi tutup.
const OPEN_DROPDOWN = '.ant-select-dropdown:not(.ant-select-dropdown-hidden)'
const OPEN_MODAL = '.ant-modal-wrap:not([style*="display: none"])'

// group: nomor langkah besar (1 buat tagihan, 2 kirim WA, 3 laba rugi) untuk badge & rail.
// target: elemen yang disorot. union: elemen tambahan yang ikut dilubangi (dropdown).
// mask: 'block' = area lain tidak bisa diklik, 'none' = hanya ring + tooltip.
// next: perpindahan step berbasis route. allow: route yang boleh dibuka di step ini.
const HOME = /^\/(dashboard)?\/?$/

export const STEPS = {
  // `/` di-redirect router ke `/dashboard`. Keduanya harus lolos, kalau tidak
  // kunci navigasi dan Redirect saling tarik dan dashboard ter-fetch terus.
  [S.WELCOME]: { group: 0, pct: 0, allow: [HOME] },
  [S.MENU_INVOICES]: {
    group: 1,
    pct: 4,
    target: '#kledo-menu-sales a[href="#/sales/invoices"]',
    fallbackTarget: 'a[href="#/sales/invoices"]',
    openSubmenu: '#kledo-menu-sales',
    placement: 'right',
    mask: 'block',
    titleId: 'financeOnboarding.menu_invoices_title',
    descId: 'financeOnboarding.menu_invoices_desc',
    next: [{ path: INVOICES, step: S.BTN_ADD }],
  },
  [S.BTN_ADD]: {
    group: 1,
    pct: 8,
    target: '#btn-add',
    placement: 'bottom',
    mask: 'block',
    titleId: 'financeOnboarding.btn_add_title',
    descId: 'financeOnboarding.btn_add_desc',
    allow: [INVOICES],
    next: [{ path: INVOICE_ADD, step: S.CONTACT_FIELD }],
  },
  [S.CONTACT_FIELD]: {
    group: 1,
    pct: 12,
    subId: 'financeOnboarding.sub_contact',
    // antd Form name="AddFinanceTransaction" memberi awalan pada id field
    target: '#AddFinanceTransaction_contact_id',
    fallbackTarget: '[id$="_contact_id"]',
    targetClosest: '.ant-select',
    union: `.contact-suggestion-container ${OPEN_DROPDOWN}`,
    placement: 'right',
    mask: 'block',
    titleId: 'financeOnboarding.contact_field_title',
    descId: 'financeOnboarding.contact_field_desc',
    hintId: 'financeOnboarding.contact_field_hint',
    allow: [INVOICE_ADD],
  },
  [S.CONTACT_MODAL]: {
    group: 1,
    pct: 18,
    subId: 'financeOnboarding.sub_contact',
    target: `${OPEN_MODAL} #btn-add`,
    placement: 'top',
    mask: 'none',
    titleId: 'financeOnboarding.contact_modal_save_title',
    descId: 'financeOnboarding.contact_modal_save_desc',
    allow: [INVOICE_ADD],
  },
  [S.PRODUCT_FIELD]: {
    group: 1,
    pct: 24,
    subId: 'financeOnboarding.sub_product',
    target: '.product-suggestion-container .ant-select',
    union: `.product-suggestion-container ${OPEN_DROPDOWN}`,
    placement: 'right',
    mask: 'block',
    titleId: 'financeOnboarding.product_field_title',
    descId: 'financeOnboarding.product_field_desc',
    hintId: 'financeOnboarding.product_field_hint',
    allow: [INVOICE_ADD],
  },
  [S.PRODUCT_CATEGORY]: {
    group: 1,
    pct: 27,
    subId: 'financeOnboarding.sub_product',
    // Form produk tanpa name → id field = nama field-nya langsung.
    target: '.product-modal #pos_product_category_id',
    targetClosest: '.ant-select',
    // Hanya dropdown kategori ini. Dropdown select lain di halaman tidak boleh
    // ikut memperlebar lubang fokus.
    union:
      '.ant-select-dropdown.suggestion-productCategories-popup-pos_product_category_id:not(.ant-select-dropdown-hidden)',
    placement: 'right',
    mask: 'block',
    titleId: 'financeOnboarding.product_category_title',
    descId: 'financeOnboarding.product_category_desc',
    hintId: 'financeOnboarding.product_category_hint',
    allow: [INVOICE_ADD],
  },
  [S.PRODUCT_MODAL]: {
    group: 1,
    pct: 30,
    subId: 'financeOnboarding.sub_product',
    target: '.product-modal #btn-add',
    placement: 'top',
    mask: 'none',
    titleId: 'financeOnboarding.product_modal_save_title',
    descId: 'financeOnboarding.product_modal_save_desc',
    allow: [INVOICE_ADD],
  },
  [S.BTN_SAVE]: {
    group: 1,
    pct: 40,
    subId: 'financeOnboarding.sub_save',
    target: '#btn-save',
    placement: 'top',
    // 'none': tombol Simpan tetap disorot, tapi form tidak dikunci — kontak & produk
    // masih bisa dilihat/diubah/ditambah sebelum menyimpan.
    mask: 'none',
    titleId: 'financeOnboarding.btn_save_title',
    descId: 'financeOnboarding.btn_save_desc',
    allow: [INVOICE_ADD],
    next: [{ path: INVOICE_DETAIL, step: S.BTN_SEND }],
  },
  [S.BTN_SEND]: {
    group: 2,
    pct: 48,
    target: '#btn-send',
    placement: 'bottom',
    mask: 'block',
    titleId: 'financeOnboarding.btn_send_title',
    descId: 'financeOnboarding.btn_send_desc',
    allow: [INVOICE_DETAIL],
  },
  [S.WA_SEND]: {
    group: 2,
    pct: 56,
    target: `${OPEN_MODAL} #btn-save`,
    placement: 'top',
    mask: 'none',
    titleId: 'financeOnboarding.wa_send_title',
    descId: 'financeOnboarding.wa_send_desc',
    allow: [INVOICE_DETAIL],
  },
  [S.WA_DONE]: {
    group: 2,
    pct: 66,
    allow: [INVOICE_DETAIL],
  },
  // Tanpa spotlight: RealtimePanel tampil sebagai kartu melayang yang mengunci klik lain
  // (scroll tetap jalan) sampai user menekan Selesai.
  [S.PL_PANEL]: {
    group: 3,
    pct: 95,
    allow: [PROFIT_LOSS],
  },
  [S.DONE]: { group: 4, pct: 100, allow: [/.*/] },
}

export const GROUP_COUNT = 3
